import { Selectorispogzpkkfxv as Selector } from './Selector.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { substringAfterLast3r0t0my8cpqhk as substringAfterLast } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { titleCase1rwupo9lkd0x6 as titleCase } from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/casing.mjs';
import { RenderContextxikz99gtpuie as RenderContext } from './RenderContext.mjs';
import { default1jaun537xukbl as default_0 } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Defaults.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  VirtualSealedInstance5g5b68tt2zol as VirtualSealedInstance,
  Concretem3lrryrg4bw0 as Concrete,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/VirtualType.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints19w9rda6g3rqz as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { toList3jhuyej2anx2q as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { weight31wqab1913ly4 as weight } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { SwapView1526g6cz7z56r as SwapView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/SwapView.commonHtml.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Companion_getInstance29ka8gqgdrya1 as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/ScreenTransitions.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { report1vfr9zf0i9d9p as report } from '../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl1tl9xt9sj2eem as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfbq6gzmblx5q7v as TextView$_set_content_$ref_pketfb,
} from '../auth/EmailProofComponent.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  cellFormub3o1hqp20e5 as cellForm,
  labeledForm2ame2d0a5lql9 as labeledForm,
  labeledView3rpvir7z2o9ii as labeledView,
  Renderer1fhwti5gmwutm as Renderer,
} from './Renderer.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function registerVirtualSealed(_this__u8e3s4) {
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(), VirtualSealedRenderer_instance);
}
function VirtualSealedRenderer$form$lambda$lambda(v) {
  return v.option_1;
}
function VirtualSealedRenderer$form$lambda$lambda_0(it) {
  return titleCase(substringAfterLast(it.name_1, _Char___init__impl__6a9atx(46)));
}
function VirtualSealedRenderer$form$lambda$lambda$lambda($next, $ser, $context, $value, $module) {
  return ($this$swap) => {
    var selectedType = $next;
    var subSerializer = $ser.get_serializableOptions_psql9y_k$()[selectedType.index_1].serializer_1;
    var subContext = new (RenderContext())(subSerializer, $context.fieldAnnotations_1);
    var tmp = (v) => v.option_1.index_1 === selectedType.index_1 ? v.value_1 : default_0(subSerializer);
    var subValue = $value.lens_drj4fu_k$(tmp, (it) => new (VirtualSealedInstance())(selectedType, ensureNotNull(it)));
    $module.form_gqhwsi_k$(subContext, subValue)($this$swap);
    return Unit_instance;
  };
}
function VirtualSealedRenderer$view$lambda$lambda$lambda($next, $ser, $context, $value, $module) {
  return ($this$swap) => {
    var selectedType = $next;
    var subSerializer = $ser.get_serializableOptions_psql9y_k$()[selectedType.index_1].serializer_1;
    var subContext = new (RenderContext())(subSerializer, $context.fieldAnnotations_1);
    var subValue = lens($value, (v) => v.option_1.index_1 === selectedType.index_1 ? v.value_1 : default_0(subSerializer));
    $module.view_ntgxjz_k$(subContext, subValue)($this$swap);
    return Unit_instance;
  };
}
var VirtualSealedRendererClass;
function VirtualSealedRenderer() {
  if (VirtualSealedRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Options';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_hu7qbk_k$(context, module_0) {
        var tmp;
        var tmp_0 = context.serializer_1;
        if (tmp_0 instanceof Concrete()) {
          tmp = 1.0;
        } else {
          tmp = -1.0;
        }
        return tmp;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_hu7qbk_k$(context, module_0);
      }
      columnWidth_ltmics_k$(context, module_0) {
        return 20.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_ltmics_k$(context, module_0);
      }
      form_y4xvnq_k$(context, value, module_0) {
        var tmp = context.serializer_1;
        var ser = tmp instanceof Concrete() ? tmp : THROW_CCE();
        return (_this__u8e3s4) => {
          var tmp = VirtualSealedRenderer$form$lambda$lambda;
          var type = value.lens_drj4fu_k$(tmp, (option) => new (VirtualSealedInstance())(option, ensureNotNull(default_0(ser.get_serializableOptions_psql9y_k$()[option.index_1].serializer_1))));
          var tt = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(type));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var this_0 = sizeConstraints(get_centered(element), VOID, VOID, VOID, VOID, VOID, get_rem(10));
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          var this_1 = themed(this_0, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (Select())(this_1.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_1.willAddChild_hz2iwc_k$(element_0);
          var tmp_0 = _Constant___init__impl__v45mub(toList(ser.sealed_1.options_1));
          element_0.bind_64a41i_k$(type, new (Constant())(tmp_0), VirtualSealedRenderer$form$lambda$lambda_0);
          element_0.onStartup_vrxh3i_k$();
          this_1.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
          var this_2 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (SwapView())(this_2.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_2.willAddChild_hz2iwc_k$(element_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
          var this_3 = element_1;
          var queue = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var alreadySwapping = {_v: false};
          reactive(this_3, 8, ($this$reactive) => {
            var c = $this$reactive.invoke_r7m7el_k$(tt);
            queue.add_utx5q5_k$(c);
            var tmp;
            if (alreadySwapping._v) {
              return Unit_instance;
            }
            alreadySwapping._v = true;
            $l$loop: while (true) {
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!!queue.isEmpty_y1axqb_k$()) {
                break $l$loop;
              }
              var next = queue.removeAt_6niowx_k$(0);
              try {
                var tmp_0 = Companion_getInstance().Fade_1;
                this_3.swap_26x94b_k$(tmp_0, VirtualSealedRenderer$form$lambda$lambda$lambda(next, ser, context, value, module_0));
              } catch ($p) {
                if ($p instanceof Exception()) {
                  var e = $p;
                  report(Exception().new_kotlin_Exception_9qyiel_k$('Failed to render ' + toString(next), e), 'SwapView.swapping');
                } else {
                  throw $p;
                }
              }
            }
            alreadySwapping._v = false;
            return Unit_instance;
          });
          element_1.onStartup_vrxh3i_k$();
          this_2.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_y4xvnq_k$(context, value, module_0);
      }
      view_56lr7j_k$(context, value, module_0) {
        var tmp = context.serializer_1;
        var ser = tmp instanceof Concrete() ? tmp : THROW_CCE();
        return (_this__u8e3s4) => {
          var tt = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(value).option_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          var this_0 = get_centered(element);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (TextView())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_0.willAddChild_hz2iwc_k$(element_0);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
          element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => titleCase(substringAfterLast($this$invoke.invoke_r7m7el_k$(tt).name_1, _Char___init__impl__6a9atx(46))));
          element_0.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
          var this_1 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (SwapView())(this_1.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_1.willAddChild_hz2iwc_k$(element_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
          var this_2 = element_1;
          var queue = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var alreadySwapping = {_v: false};
          reactive(this_2, 8, ($this$reactive) => {
            var c = $this$reactive.invoke_r7m7el_k$(tt);
            queue.add_utx5q5_k$(c);
            var tmp;
            if (alreadySwapping._v) {
              return Unit_instance;
            }
            alreadySwapping._v = true;
            $l$loop: while (true) {
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!!queue.isEmpty_y1axqb_k$()) {
                break $l$loop;
              }
              var next = queue.removeAt_6niowx_k$(0);
              try {
                var tmp_0 = Companion_getInstance().Fade_1;
                this_2.swap_26x94b_k$(tmp_0, VirtualSealedRenderer$view$lambda$lambda$lambda(next, ser, context, value, module_0));
              } catch ($p) {
                if ($p instanceof Exception()) {
                  var e = $p;
                  report(Exception().new_kotlin_Exception_9qyiel_k$('Failed to render ' + toString(next), e), 'SwapView.swapping');
                } else {
                  throw $p;
                }
              }
            }
            alreadySwapping._v = false;
            return Unit_instance;
          });
          element_1.onStartup_vrxh3i_k$();
          this_1.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_56lr7j_k$(context, value, module_0);
      }
      cellView_ew583h_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => titleCase(substringAfterLast($this$invoke.invoke_r7m7el_k$(value).option_1.name_1, _Char___init__impl__6a9atx(46))));
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      cellView_2dvin1_k$(context, value, module_0) {
        return this.cellView_ew583h_k$(context, value, module_0);
      }
    }
    protoOf($).cellForm_4mayde_k$ = cellForm;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'VirtualSealedRenderer', VOID, VOID, [Renderer()]);
    VirtualSealedRendererClass = $;
  }
  return VirtualSealedRendererClass;
}
var VirtualSealedRenderer_instance;
function VirtualSealedRenderer_getInstance() {
  return VirtualSealedRenderer_instance;
}
//region block: init
VirtualSealedRenderer_instance = new (VirtualSealedRenderer())();
//endregion
//region block: exports
export {
  registerVirtualSealed as registerVirtualSealed20oawc47pq9zf,
};
//endregion

//# sourceMappingURL=VirtualSealedRenderer.mjs.map
